function remove_item_from_selection(sender) {
    confirm("Weet u zeker dat u dit item uit de selectie wilt verwijderen?",function() {
        var $ = jQuery.noConflict();
        var tr = $(sender).parents('tr');
        var table = tr.parents('table');
        var f_k = table.attr('data-filters-key');
        var id = tr.attr('data-id');

        table.parent().find('input[data-'+f_k+'-filter][value="'+id+'"]').remove();
        tr.remove();
    });

    return false;
}